<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <!-- HEADER -->
          <div v-if="companyHeader" class="text-center mb-4">
            <img
              v-if="getCurrentCompany?.header_image"
              :src="`${getFileServerUrl}${getCurrentCompany.header_image}`"
              style="width: 100%;"
            />

            <div v-else class="company-default-header">
              <h3 class="company-name">{{ getCurrentCompany?.name }}</h3>
              <p>{{ getCurrentCompany?.address }}</p>
              <p>{{ getCurrentCompany?.mobile }} | {{ getCurrentCompany?.email }}</p>
            </div>
          </div>

          <!-- TITLE -->
          <h2 class="report-title text-center mb-6" style="margin-bottom: 24px !important;">
            PURCHASE RETURN DETAILS
          </h2>

          <!-- MASTER INFO -->
          <table class="info-table mb-6" style="margin-bottom: 24px !important;">
            <tbody>
              <tr>
                <td><strong>Return Code</strong></td>
                <td>{{ code }}</td>
                <td><strong>Date</strong></td>
                <td>{{ formatDateView(receive_date) }}</td>
              </tr>

              <tr>
                <td><strong>Supplier</strong></td>
                <td>{{ supplier?.name || supplier?.supplier_name }}</td>
                <td><strong>Warehouse</strong></td>
                <td>{{ warehouse?.name }}</td>
              </tr>

              <tr>
                <td><strong>PO Code</strong></td>
                <td>{{ pur_order_master?.code }}</td>
                <td><strong>Remarks</strong></td>
                <td>{{ remarks }}</td>
              </tr>
            </tbody>
          </table>

          <!-- DETAILS TABLE -->
          <table class="details-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Code</th>
                <th>Item</th>
                <th>Qty</th>
                <th>Unit</th>
                <th>Rate</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, i) in cart" :key="i">
                <td>{{ i + 1 }}</td>
                <td>{{ item.product_code }}</td>
                <td>{{ item.product_name }}</td>
                <td class="text-right">{{ item.qty }}</td>
                <td class="text-center">{{ item.unit_name }}</td>
                <td class="text-right">{{ formatNumber(item.rate) }}</td>
                <td class="text-right">{{ formatNumber(item.total) }}</td>
              </tr>

              <tr v-if="!cart.length">
                <td colspan="7" class="text-center text-red">
                  No data found
                </td>
              </tr>
            </tbody>
          </table>

          <!-- TOTAL -->
          <div class="total-section mt-6">
            <div class="words">
              <strong>{{ convertNumberToWords(total_amount || 0) }}</strong>
            </div>
            <div class="amount">
              <strong>{{ formatNumber(total_amount) }}</strong>
            </div>
          </div>

          <!-- SIGNATURE -->
          <div class="signature mt-10">
            <div>
              <p class="sign-line">Receiver Signature</p>
            </div>

            <div>
              <p class="sign-line">
                {{ getCurrentCompany?.name }}
              </p>
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- PRINT BUTTON -->
    <v-row class="d-print-none mt-4">
      <v-col class="text-center">
        <v-btn color="primary" @click="print">
          <v-icon>mdi-printer</v-icon> Print
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import convertNumberToWords from "@/plugins/numberToWord";
import { formatDateView } from "@/plugins/helpers";
import Axios from "axios";
import { prefix } from "@/store/api";

export default {
  data() {
    return {
      code: "",
      receive_date: "",
      remarks: "",
      supplier: {},
      warehouse: {},
      pur_order_master: {},
      cart: [],
      total_amount: 0,
      companyHeader: true,
    };
  },

  methods: {
    convertNumberToWords,
    formatDateView,

    formatNumber(val) {
      return Number(val || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    print() {
      const content = document.getElementById("printable-area").outerHTML;
      const win = window.open();

      win.document.write(`
        <html>
          <head>
            <title>Print</title>
            <style>
              body { font-family: Arial; }
              table { width:100%; border-collapse: collapse; }
              th, td { border:1px solid #000; padding:5px; font-size:12px; }
              th { background:#f0f0f0; }
              .text-center{text-align:center;}
              .text-right{text-align:right;}
              .report-title{font-size:18px; font-weight:bold;}
              .info-table td{padding:6px;}
              .total-section{display:flex; justify-content:space-between; margin-top:20px;}
              .signature{display:flex; justify-content:space-between; margin-top:60px;}
              .sign-line{border-top:1px solid #000; width:200px; text-align:center;}
            </style>
          </head>
          <body>${content}</body>
        </html>
      `);

      win.document.close();
      win.print();
    },
  },

  computed: {
    getCurrentCompany() {
      return this.$store.getters.getCurrentCompany;
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
  },

  mounted() {
    const id = this.$route.params.id;

    this.$store
      .dispatch("purchaseReturnDetails", {purchase_return_master_id: id})
      .then((res) => {
        const data = res.data.data;
        this.code = data.code;
        this.receive_date = data.return_date;
        this.remarks = data.remarks;
        this.total_amount = data.total;

        this.supplier = data.supplier;
        this.warehouse = data.warehouse;
        this.pur_order_master = data.po_receive_master || {};

        this.cart = (data.details || []).map((d) => ({
          product_code: d.product?.code,
          product_name: d.product?.name,
          qty: d.qty,
          unit_name: d.product?.unit?.name,
          rate: d.rate,
          total: d.amount || d.qty * d.rate,
        }));
      });
  },
};
</script>

<style scoped>
.full-height { min-height: 70vh; }

.report-paper {
  background: white;
}

.report-title {
  font-size: 18px;
  font-weight: bold;
}

.info-table,
.details-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.info-table td,
.details-table th,
.details-table td {
  border: 1px solid #000;
  padding: 6px;
}

.details-table th {
  background: #f5f5f5;
}

.text-right { text-align: right; }
.text-center { text-align: center; }

.total-section {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.signature {
  display: flex;
  justify-content: space-between;
}

.sign-line {
  border-top: 1px solid #000;
  width: 200px;
  text-align: center;
  padding-top: 5px;
}
.mb-6 {
  margin-bottom: 24px !important;
}
</style>